"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _GcsPlugin = /*#__PURE__*/ _interop_require_default(require("./GcsPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _GcsPlugin.default,
    id: 'gcs',
    title: 'GCS',
    version: '0.0.4',
    logo: 'plugins/gcs.png',
    description: 'Google Cloud Storage is a RESTful online file storage web service for storing and accessing data on Google Cloud Platform infrastructure.',
    price: 'Free',
    tags: 'Storage',
    category: 'Storage',
    inputs: {
        title: 'Configure Google Cloud Storage',
        items: [
            {
                key: 'bucket',
                label: 'Bucket Name',
                placeholder: 'Bucket Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'client_email',
                label: 'Client Email',
                placeholder: 'Client Email',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'private_key',
                label: 'Private Key',
                placeholder: 'Private Key',
                type: _nocodbsdk.XcType.Password,
                required: true
            },
            {
                key: 'project_id',
                label: 'Project ID',
                placeholder: 'Project ID',
                type: _nocodbsdk.XcType.SingleLineText,
                required: false
            },
            {
                key: 'uniform_bucket_level_access',
                label: 'Uniform Bucket Level Access',
                type: _nocodbsdk.XcType.Checkbox,
                required: false
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Attachments will now be stored in Google Cloud Storage.',
        msgOnUninstall: ''
    }
};
const _default = config;
